import { eventDateDisplay } from "./event.model";

export const eventUserModel = (data = {}) => {
  const user = data.user || {};
  return {
    uuid: data.uuid,
    userUUID: user.uuid,
    status: data.status == null ? null : Number(data.status),
    name:
      user.name ||
      [user.first_name, user.last_name].filter(Boolean).join(" ") ||
      user.email ||
      "—",
    email: user.email || "—",
    phone: user.phone
      ? [user.phone_code, user.phone].filter(Boolean).join(" ")
      : "—",
    image: user.image || "",
    createdAt: eventDateDisplay(data.created_at),
  };
};
